// Ищем существующую секцию пререндера: обёртка изменила бы дерево и раскладку главной.
export const waitForMapHydration = () => {
  const section = document.querySelector('section[aria-labelledby="delivery-map-title"]');
  // При SPA-переходе lazy вызывается до появления DOM карты — ждать нечего.
  if (!section) return { ready: Promise.resolve(), onHydrated: () => {} };

  let activate = () => {};
  const ready = new Promise<void>((resolve) => {
    activate = resolve;
  });
  let intersection: IntersectionObserver | undefined;
  let removal: MutationObserver | undefined;
  let pendingClick: { target: EventTarget; event: MouseEvent } | undefined;
  const events = ['pointerover', 'pointerdown', 'focusin', 'touchstart', 'click'];
  const open = () => {
    intersection?.disconnect();
    intersection = undefined;
    window.removeEventListener('scroll', onScroll);
    activate();
  };
  // Быстрый переход к подвалу может перескочить секцию целиком: IntersectionObserver
  // тогда не видит пересечения. Пройденную карту тоже отпускаем, иначе её Suspense
  // может удержать commit навигации (в том числе прокрутку по логотипу на главной).
  const onScroll = () => {
    if (section.getBoundingClientRect().top <= window.innerHeight) open();
  };
  const cleanup = () => {
    open();
    removal?.disconnect();
    removal = undefined;
    for (const event of events) document.removeEventListener(event, handleInteraction, true);
  };
  const handleInteraction = (event: Event) => {
    if (!event.composedPath().includes(section)) return;
    // React 19 повторяет pointerover, но быстрый click на всё ещё suspended-границе теряется.
    // Сохраняем последнее нажатие до commit карты; штатное действие ссылки тоже откладываем.
    if (event.type === 'click' && event instanceof MouseEvent && event.target) {
      pendingClick = { target: event.target, event };
      event.preventDefault();
      event.stopPropagation();
    }
    open();
  };
  const onHydrated = () => {
    cleanup();
    const click = pendingClick;
    pendingClick = undefined;
    if (click && section.isConnected) {
      click.target.dispatchEvent(new MouseEvent('click', click.event));
    }
  };

  // На document в capture — раньше React, который может остановить событие на ещё
  // негидратированной границе. После commit все эти обработчики снимаются.
  for (const event of events) document.addEventListener(event, handleInteraction, true);
  // lazy кеширует обещание навсегда: уход с главной должен отпустить его и для SPA-возврата.
  removal = new MutationObserver(() => {
    if (!section.isConnected) {
      pendingClick = undefined;
      cleanup();
    }
  });
  removal.observe(document.documentElement, { childList: true, subtree: true });

  const rect = section.getBoundingClientRect();
  if (
    !('IntersectionObserver' in window) ||
    rect.top <= window.innerHeight ||
    (document.activeElement && section.contains(document.activeElement))
  ) {
    open();
  } else {
    // До одного экрана запаса, но не захватываем карту уже на первом экране десктопа.
    // Половина начального зазора оставляет время на гидратацию ещё до появления секции.
    const margin = Math.min(window.innerHeight, Math.max(0, rect.top - window.innerHeight) / 2);
    intersection = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) open();
      },
      { rootMargin: `${margin}px 0px` },
    );
    intersection.observe(section);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  return { ready, onHydrated };
};
